export enum ProductType {
    profile = "profile",
    connection = "connection",
}